import { render, staticRenderFns } from "./RawDeliveriesCSV.vue?vue&type=template&id=610fcf8e&lang=pug&"
import script from "./RawDeliveriesCSV.vue?vue&type=script&lang=ts&"
export * from "./RawDeliveriesCSV.vue?vue&type=script&lang=ts&"
import style0 from "./RawDeliveriesCSV.vue?vue&type=style&index=0&id=610fcf8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports